// import React, { useState, useEffect, useContext } from 'react';
// import ServiceItemTable from './ServiceItemTable';
// import ServiceItemForm from './ServiceItemForm';
// import './NewServiceItem.css';
// import axios from 'axios';
// import baseURL from '../ApiUrl/Apiurl';
// import Swal from 'sweetalert2';
// import { AuthContext } from '../AuthContext/AuthContext';
// import { useCompany } from '../AuthContext/CompanyContext';

// const ServiceItem = () => { 
//   const [showForm, setShowForm] = useState(false);
//   const [serviceItems, setServiceItems] = useState([]);
//   const { selectedCompany } = useCompany();
//   const [refreshContractFlag, setRefreshContractFlag] = useState(0);
//   const [formData, setFormData] = useState({
//     serial_number: "",
//     product: "",
//     customer: "",
//     pcb_serial_number: "",
//     location: "",
//     location_latitude: "",
//     service_item_name: "",
//     location_longitude: "",
//     installation_date: "",
//     warranty_start_date: "",
//     warranty_end_date: "",
//     contract_end_date: "",
//     status: "Active",
//     iot_status: "Online",
//     product_description: "",
//     pm_group: "",
//     bc_number: "",
//     ship_to_code: ""
//   });
//   const [isEditMode, setIsEditMode] = useState(false);

//   const { userId } = useContext(AuthContext);
//   console.log("User ID from context:", userId);
//   console.log("Selected Company from context:", selectedCompany);

//   // Fetch service items on load
//   useEffect(() => {
//     fetchServiceItems();
//   }, [selectedCompany, userId]);

//   const refreshContracts = () => {
//     setRefreshContractFlag(prev => prev + 1);
//   };

//   const fetchServiceItems = async () => {
//     try {
//       const response = await axios.get(`${baseURL}/service-items/?user_id=${userId}&company_id=${selectedCompany}`);
//       console.log("url", `${baseURL}/service-items/?user_id=${userId}&company_id=${selectedCompany}`);
//       if (response.data.status === "success") {
//         setServiceItems(response.data.data);
//       } else {
//         console.error("Failed to fetch service items.");
//       }
//     } catch (error) {
//       console.error("API Error:", error);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = (newServiceItem) => {
//     if (isEditMode) {
//       setServiceItems(serviceItems.map(item => 
//         item.service_item_id === newServiceItem.service_item_id ? newServiceItem : item
//       ));
//     } else {
//       setServiceItems([newServiceItem, ...serviceItems]);
//     }
//     resetForm();
//     setShowForm(false);
//   };

//   const handleEdit = (item) => {
//     setFormData({
//       service_item_id: item.service_item_id,
//       serial_number: item.serial_number,
//       product: item.product,
//       customer: item.customer,
//       location: item.location,
//       location_latitude: item.location_latitude,
//       service_item_name: item.service_item_name,
//       pcb_serial_number: item.pcb_serial_number,
//       location_longitude: item.location_longitude,
//       installation_date: item.installation_date,
//       warranty_start_date: item.warranty_start_date,
//       warranty_end_date: item.warranty_end_date,
//       contract_end_date: item.contract_end_date,
//       status: item.status,
//       iot_status: item.iot_status,
//       last_service: item.last_service,
//       product_description: item.product_description,
//       pm_group: item.pm_group,
//       bc_number: item.bc_number || "",
//       ship_to_code: item.ship_to_code || "",
//       created_at: item.created_at,
//       created_by: item.created_by
//     });
//     setIsEditMode(true);
//     setShowForm(true);
//   };

//   const handleDelete = async (serviceItemId) => {
//     Swal.fire({
//       title: 'Are you sure?',
//       text: "You won't be able to revert this!",
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#d33',
//       cancelButtonColor: '#3085d6',
//       confirmButtonText: 'Yes, delete it!'
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         try {
//           const token = localStorage.getItem("authToken");
//           await axios.delete(`${baseURL}/service-items/${serviceItemId}/`, {
//             headers: {
//               ...(token && { Authorization: `Bearer ${token}` }),
//             }
//           });
//           setServiceItems(serviceItems.filter(item => item.service_item_id !== serviceItemId));

//           Swal.fire({
//             icon: 'success',
//             title: 'Deleted!',
//             text: 'Service item has been deleted.',
//           });
//         } catch (error) {
//           console.error('Error deleting service item:', error);
//           Swal.fire({
//             icon: 'error',
//             title: 'Error!',
//             text: 'Failed to delete service item.',
//           });
//         }
//       }
//     });
//   };

//   const resetForm = () => {
//     setFormData({
//       serial_number: "",
//       product: "",
//       customer: "",
//       location: "",
//       location_latitude: "",
//       location_longitude: "",
//       installation_date: "",
//       service_item_name: "",
//       pcb_serial_number: "",
//       warranty_start_date: "",
//       warranty_end_date: "",
//       contract_end_date: "",
//       status: "Active",
//       iot_status: "Online",
//       product_description: "",
//       pm_group: "",
//       bc_number: "",
//       ship_to_code: ""
//     });
//     setIsEditMode(false);
//   };

//   const toggleForm = () => {
//     resetForm();
//     setShowForm((prev) => !prev);
//   };

//   return (
//     <div>
//       {!showForm ? (
//         <ServiceItemTable 
//           serviceItems={serviceItems} 
//           onAddNew={toggleForm}
//           onEdit={handleEdit}
//           onDelete={handleDelete}
//           selectedCompany={selectedCompany}
//           userId={userId}
//           refreshContracts={refreshContractFlag}
//         />
//       ) : (
//         <ServiceItemForm 
//           formData={formData} 
//           onChange={handleChange} 
//           onSubmit={handleSubmit} 
//           onCancel={toggleForm}
//           isEditMode={isEditMode}
//           userId={userId}
//         />
//       )}
//     </div>
//   );
// };

// export default ServiceItem;



import React, { useState, useEffect, useContext } from 'react';
import ServiceItemTable from './ServiceItemTable';
import ServiceItemForm from './ServiceItemForm';
import './NewServiceItem.css';
import axios from 'axios';
import baseURL from '../ApiUrl/Apiurl';
import Swal from 'sweetalert2';
import { AuthContext } from '../AuthContext/AuthContext';
import { useCompany } from '../AuthContext/CompanyContext';

// =============================================================================
// ✅ Generic PROGRESSIVE paginated fetch.
//
// Fetches page 1 first and hands it to `onUpdate` immediately — that's what
// makes the first paint fast. It then keeps walking the remaining pages in
// the background (via pagination.has_next / pagination.next_page) and calls
// `onUpdate` again after every page, so the UI updates live as more data
// streams in instead of blocking until the whole dataset is loaded.
//
// `pageSize` only controls how many records come back per request — the
// loop keeps going until the API reports has_next: false, so no records are
// ever skipped no matter how large the total count is or what size you pick.
// =============================================================================
const fetchPaginatedProgressive = async (url, extraParams = {}, onUpdate, pageSize = 10) => {
  let all = [];
  let page = 1;
  let hasNext = true;

  while (hasNext) {
    try {
      const response = await axios.get(url, {
        params: { ...extraParams, page, page_size: pageSize },
      });
      const body = response.data;

      let pageItems = [];
      if (Array.isArray(body)) pageItems = body;
      else if (Array.isArray(body?.data)) pageItems = body.data;
      else if (Array.isArray(body?.results)) pageItems = body.results;

      all = all.concat(pageItems);
      onUpdate(all);

      // Detect "is there another page" across a couple of possible shapes,
      // so an endpoint using a different pagination envelope than
      // /service-items/ doesn't silently stop after page 1:
      //   - custom: { pagination: { has_next, next_page, total_count } }
      //   - classic DRF PageNumberPagination: { next: "<url>"|null, count }
      let hasNextPage = false;
      let nextPageNum = page + 1;

      if (body?.pagination) {
        hasNextPage = !!body.pagination.has_next;
        nextPageNum = body.pagination.next_page || nextPageNum;
      } else if (Object.prototype.hasOwnProperty.call(body || {}, 'next')) {
        hasNextPage = !!body.next;
      } else if (typeof body?.count === 'number') {
        hasNextPage = all.length < body.count;
      }

      if (hasNextPage) {
        page = nextPageNum;
      } else {
        hasNext = false;
      }
    } catch (error) {
      console.error(`Failed to fetch paginated data from ${url} (page ${page})`, error);
      hasNext = false;
    }
  }

  return all;
};

const ServiceItem = () => {  
  const [showForm, setShowForm] = useState(false);
  const [serviceItems, setServiceItems] = useState([]);
  const [loadingServiceItems, setLoadingServiceItems] = useState(false);
  const { selectedCompany } = useCompany();
  const [refreshContractFlag, setRefreshContractFlag] = useState(0);
  const [formData, setFormData] = useState({
    serial_number: "",
    product: "",
    customer: "",
    pcb_serial_number: "",
    location: "",
    location_latitude: "",
    service_item_name: "",
    location_longitude: "",
    installation_date: "",
    warranty_start_date: "",
    warranty_end_date: "",
    contract_end_date: "",
    status: "Active",
    iot_status: "Online",
    product_description: "",
    pm_group: "",
    bc_number: "",
    ship_to_code: ""
  });
  const [isEditMode, setIsEditMode] = useState(false);

  const { userId } = useContext(AuthContext);
  console.log("User ID from context:", userId);
  console.log("Selected Company from context:", selectedCompany);

  // Handle browser back button and swipe gesture when form is open
  useEffect(() => {
    if (showForm) {
      window.history.pushState({ formOpen: true }, '', window.location.pathname);
      
      const handlePopState = (event) => {
        if (showForm) {
          event.preventDefault();
          resetForm();
          setShowForm(false);
          window.history.pushState({ formOpen: true }, '', window.location.pathname);
        }
      };
      
      window.addEventListener('popstate', handlePopState);
      
      return () => {
        window.removeEventListener('popstate', handlePopState);
      };
    }
  }, [showForm]);

  // Fetch service items on load
  useEffect(() => {
    fetchServiceItems();
  }, [selectedCompany, userId]);

  const refreshContracts = () => {
    setRefreshContractFlag(prev => prev + 1);
  };

  // ✅ CHANGED: /service-items/ is paginated. Page 1 (default size 10) is
  // fetched and shown immediately — this is what makes initial load fast —
  // then the remaining pages stream in behind the scenes and get appended
  // as they arrive, so the table (and its search box) end up with the full
  // list without the user ever staring at a blank/loading screen for long.
  const fetchServiceItems = async () => {
    setLoadingServiceItems(true);
    let firstPageArrived = false;

    try {
      await fetchPaginatedProgressive(
        `${baseURL}/service-items-pagination/`,
        { user_id: userId, company_id: selectedCompany },
        (partialItems) => {
          setServiceItems(partialItems);
          if (!firstPageArrived) {
            firstPageArrived = true;
            setLoadingServiceItems(false); // unblock the UI as soon as page 1 is in
          }
        },
        10 // matches the API's default page size for the fastest possible first paint
      );
    } catch (error) {
      console.error("API Error:", error);
      setLoadingServiceItems(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (newServiceItem) => {
    if (isEditMode) {
      setServiceItems(serviceItems.map(item => 
        item.service_item_id === newServiceItem.service_item_id ? newServiceItem : item
      ));
    } else {
      setServiceItems([newServiceItem, ...serviceItems]);
    }
    resetForm();
    setShowForm(false);
  };

  const handleEdit = (item) => {
    setFormData({
      service_item_id: item.service_item_id,
      serial_number: item.serial_number,
      product: item.product,
      customer: item.customer,
      location: item.location,
      location_latitude: item.location_latitude,
      service_item_name: item.service_item_name,
      pcb_serial_number: item.pcb_serial_number,
      location_longitude: item.location_longitude,
      installation_date: item.installation_date,
      warranty_start_date: item.warranty_start_date,
      warranty_end_date: item.warranty_end_date,
      contract_end_date: item.contract_end_date,
      status: item.status,
      iot_status: item.iot_status,
      last_service: item.last_service,
      product_description: item.product_description,
      pm_group: item.pm_group,
      bc_number: item.bc_number || "",
      ship_to_code: item.ship_to_code || "",
      created_at: item.created_at,
      created_by: item.created_by
    });
    setIsEditMode(true);
    setShowForm(true);
  };

  const handleDelete = async (serviceItemId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const token = localStorage.getItem("authToken");
          await axios.delete(`${baseURL}/service-items/${serviceItemId}/`, {
            headers: {
              ...(token && { Authorization: `Bearer ${token}` }),
            }
          });
          setServiceItems(serviceItems.filter(item => item.service_item_id !== serviceItemId));

          Swal.fire({
            icon: 'success',
            title: 'Deleted!',
            text: 'Service item has been deleted.',
          });
        } catch (error) {
          console.error('Error deleting service item:', error);
          Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: 'Failed to delete service item.',
          });
        }
      }
    });
  };

  const resetForm = () => {
    setFormData({
      serial_number: "",
      product: "",
      customer: "",
      location: "",
      location_latitude: "",
      location_longitude: "",
      installation_date: "",
      service_item_name: "",
      pcb_serial_number: "",
      warranty_start_date: "",
      warranty_end_date: "",
      contract_end_date: "",
      status: "Active",
      iot_status: "Online",
      product_description: "",
      pm_group: "",
      bc_number: "",
      ship_to_code: ""
    });
    setIsEditMode(false);
  };

  const toggleForm = () => {
    resetForm();
    setShowForm((prev) => !prev);
  };

  return (
    <div>
      {!showForm ? (
        <ServiceItemTable 
          serviceItems={serviceItems} 
          onAddNew={toggleForm}
          onEdit={handleEdit}
          onDelete={handleDelete}
          selectedCompany={selectedCompany}
          userId={userId}
          refreshContracts={refreshContractFlag}
        />
      ) : (
        <ServiceItemForm 
          formData={formData} 
          onChange={handleChange} 
          onSubmit={handleSubmit} 
          onCancel={toggleForm}
          isEditMode={isEditMode}
          userId={userId}
        />
      )}
    </div>
  );
};

export default ServiceItem;